export const version = {
    major: 4,
    minor: 2,
    patch: 1,
};
